<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">Happily<br/> Ever After</span><br/><br/></p>
<p class="center">THE<br/>FAIRY-TALE FORMULA<br/>FOR LASTING LOVE<br/><br/></p>
<p class="center"><strong>WENDY PARIS</strong><br/><br/><br/></p>
<p class="center"><img alt="PNG" src="OEBPS/images/9780062026323_L04.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062026323_epub_tp_r1.vue?07825d21